import { UserProfile } from 'fitbeat.gym-core';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CheckCircleSolid from '../../../assets/icons/check-circle-solid.svg';
import PlusCircleOutline from '../../../assets/icons/plus-circle-outline.svg';
import { TranslateProp } from '../../../common-types';
import connectedApps from '../../../ConnectedApps';
import Theme from '../../../theme';
import { ConnectingLoaderIcon } from '../../../ui/components/Icons/ConnectingLoaderIcon';
import {
  toggleHeartRateMonitorModalStudioVisible,
} from '../../../ui/redux/uiActions';
import { defaultScale, Logger } from '../../../utils';
import useRealtimeMetrics from '../../../utils/useRealtimeMetrics';
import StudioWorkoutStartingHeaderButton from './StudioWorkoutStartingHeaderButton';

interface IParentProps {
  userProfile: UserProfile;
  t: TranslateProp;
}

interface IMapDispatchToProps {
  openSetupHRModal(): void;
}

const HeartRate: FunctionComponent<IParentProps & IMapDispatchToProps> = (
  {
    userProfile,
    openSetupHRModal,
    t,
  },
) => {
  const [canUseConnectedAppForHeartRate, setCanUseConnectedAppForHeartRate] = useState(false);
  const realtimeMetric = useRealtimeMetrics(userProfile.uid, userProfile.heartRateMonitors?.studio);

  useEffect(() => {
    connectedApps.canUseConnectedAppForHeartRate()
      .then((canUse) => setCanUseConnectedAppForHeartRate(canUse))
      .catch((err) => Logger.notify(err));
  });

  const canReceiveMetricsFromGymServer = userProfile.heartRateMonitors?.studio || canUseConnectedAppForHeartRate;
  if (!canReceiveMetricsFromGymServer) {
    return (
      <StudioWorkoutStartingHeaderButton
        Icon={PlusCircleOutline}
        iconColor={Theme.PRIMARY}
        text={t('StartingStudioWorkoutHeaderHeartRate')}
        subText={t('StartingStudioWorkoutHeaderAddHeartSubText')}
        onPress={openSetupHRModal}
        iconSize={defaultScale(22)}
      />
    );
  }

  if (realtimeMetric?.liveMetrics) {
    const subtext = realtimeMetric.liveMetrics.latestHeartRate === 0
      ? t('StartingStudioWorkoutHeartRateConnected')
      : t('StartingStudioWorkoutHeartRate', { heartRate: realtimeMetric.liveMetrics.latestHeartRate.toString(10) });
    return (
      <StudioWorkoutStartingHeaderButton
        Icon={CheckCircleSolid}
        iconColor={Theme.GREEN}
        text={t('StartingStudioWorkoutHeaderHeartRate')}
        subText={subtext}
        onPress={openSetupHRModal}
        iconSize={defaultScale(22)}
      />
    );
  }

  return (
    <StudioWorkoutStartingHeaderButton
      Icon={ConnectingLoaderIcon}
      iconColor={Theme.PRIMARY}
      text={t('StartingStudioWorkoutHeaderHeartRate')}
      subText={t('StartingStudioWorkoutHeaderAwaitingConnection')}
      onPress={openSetupHRModal}
      iconSize={defaultScale(22)}
    />
  );
};

const mapDispatchToProps = (dispatch): IMapDispatchToProps => ({
  openSetupHRModal: () => dispatch(toggleHeartRateMonitorModalStudioVisible(true)),
});

export default connect(null, mapDispatchToProps)(HeartRate);
